import { Avatar, Grid, SxProps, Typography } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { userApi } from '@/redux/api/userApi';
import { IUser } from '@/redux/models';

type AutoCompleteUsersProps = {
    onChange: (user: IUser | any) => void,
    value: IUser | undefined,
    filter?: { companyId?: number },
    label?: string
    size?: 'small' | 'medium'
    sx?: SxProps<any>
}

export default function AutoCompleteUsers({ onChange, filter, value, label = "Pedir a usuario", size, sx }: AutoCompleteUsersProps) {
    const [open, setOpen] = useState(false);
    const [getUsers] = userApi.endpoints.getAllUsers.useLazyQuery();
    const [userList, setUserList] = useState<readonly IUser[]>([]);
    const loading = open && userList.length === 0;

    useEffect(() => {
        if (!loading) {
            return undefined;
        }
        getUsers({ companyId: filter?.companyId }).unwrap().then((response) => {
            setUserList(response.data);

        }).catch((error) => {
            console.error('Error fetching users:', error);
        });


    }, [getUsers, loading, filter?.companyId]);

    useEffect(() => {
        value && onChange(value);
    }, [value, onChange]);



    return (
        <>
            <Autocomplete
                size={size}
                sx={sx}
                fullWidth
                value={value || null}
                open={open}
                onOpen={() => {
                    setOpen(true);
                }}
                onClose={() => {
                    setOpen(false);
                }}
                isOptionEqualToValue={(option, value) => option.cuit === value.cuit}
                getOptionLabel={(option) => option.nombre + ' ' + option.apellido + ' - ' + option.cuit}
                options={userList}
                loading={loading}
                onChange={(event, newValue) => {
                    onChange(newValue);
                }}
                loadingText="Cargando..."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />
                )}
                renderOption={(props, option, { selected }) => (
                    <li {...props}>
                        <Grid container >
                            <Grid item xs={3} textAlign='center' >
                                <Avatar src={option.fotoPerfil} sx={{ margin: '0 auto', alignSelf: 'center' }} />
                            </Grid>
                            <Grid item xs={9}>
                                <Typography noWrap>
                                    {option.nombre} {option.apellido}
                                </Typography>
                                <Typography>
                                    {option.cuit}
                                </Typography>
                            </Grid>
                        </Grid>
                    </li>
                )}

            />
        </>

    );
}